import React from "react";

import "./button.scss"

export default class Buttons extends React.Component{
    constructor(props){
        super(props);
        this.state={
            value:null
        }
        
    }
    static defaultProps={
        data:[],
        
    }
    changeBtn(val){
        this.setState({
            value:val
        })
        this.props.activeBack(val);
    }
    render(){
        let that=this;
        return(
            <div style={this.props.style} className="buttons">
                <ul>
                    {
                        this.props.data.map((s)=>{
                            return <li key={s.val} onClick={()=>{this.changeBtn(s.val)}} className={this.state.value==s.val?'activeLi':""}>{s.name}</li>
                        })
                    }
                </ul>
                
            </div>
        )
    }
    componentWillReceiveProps(nextProps) {
        
        
        
    }
    componentDidMount(){
        this.setState({
            value:this.props.defaultValue
        })
    }
}

